import axios from 'axios';

// Global logout function for handling token expiration
let globalLogout = null;
export const setGlobalLogout = (logoutFunction) => {
  globalLogout = logoutFunction;
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://info.kissdatelove.com';

// Create base axios instance
export const apiClient = axios.create({
  baseURL: `${API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Single response interceptor that handles everything
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    
    // Handle 401 Unauthorized - Token expired or invalid
    if (error.response?.status === 401 && !originalRequest._retry) {
      console.log('🔐 401 error - clearing web auth data');
      originalRequest._retry = true;
      
      try {
        // Clear all auth data from localStorage
        const authKeys = ['token', 'username', 'userId', 'member_id', 'currentUserMemberTypeId'];
        authKeys.forEach(key => {
          localStorage.removeItem(key);
          sessionStorage.removeItem(key);
        });
        
        // Clear authorization header
        delete apiClient.defaults.headers.common['Authorization'];
        
        // Trigger logout in AuthContext
        if (globalLogout) {
          console.log('🔓 Calling global logout due to 401');
          globalLogout();
        }
        
        console.log('🔓 Web auth data cleared due to 401 error');
        
      } catch (clearError) {
        console.error('❌ Error clearing web auth data:', clearError);
      }
    }
    
    // Handle CORS errors
    if (error.response?.status === 0 && error.message.includes('Network Error')) {
      console.error('CORS or Network Error:', error);
    }
    
    return Promise.reject(error);
  }
);

// Token validation function
export const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    // Basic JWT token structure check
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    // Decode the payload (second part)
    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp > currentTime;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

// Export the setup function for backward compatibility
export const setupInterceptors = (navigate) => {
  // Interceptors are already set up above
  // This function is kept for backward compatibility
  console.log('📡 API interceptors already configured');
  return apiClient;
};

// Default export
export default apiClient;